import { BACKEND_URL } from './backend';

export async function api(path, options = {}) {
  const token = localStorage.getItem('auth_token');
  const headers = { ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers };
  const response = await fetch(`${BACKEND_URL}/api${path}`, { ...options, credentials: 'include', headers });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const detail = body.detail;
    throw new Error(typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(d => d.msg).join('; ') : `Request failed (${response.status})`);
  }
  if (options.blob) return response.blob();
  return response.status === 204 ? null : response.json();
}